// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#shu-booking-form .textarea{font-family:inherit;-webkit-transition:border 0.2s ease-out;transition:border 0.2s ease-out;border-radius:4px;border:1px solid #d5e6f8;border-bottom:2px solid #3788d8;background:#fcfdfd;resize:vertical;color:#036;font-size:1.2rem;padding:0.3em 0.5em;margin:0;outline:none;width:100%}#shu-booking-form .input:hover{background:rgba(231,241,248,0.5)}#shu-booking-form .input:focus{background:#fcfdfd}\n", ""]);
// Exports
module.exports = exports;
